import { MailFileDto, MailFilesWithRightsDTO, MailPreviousValidationDTO } from 'src/app/shared/interfaces';
import { Contact } from '../iContact/contact/contact';
import { PastellStatus } from '../iCourrier/pastell/pastell-status';
import { DigitalCentersVMDTO } from 'src/app/shared/interfaces/digital-centers/digital-centers-vm-dto.interface';
import { EmailSender } from '../iCourrier/email/email-sender';
import { DateUtils } from '@devinforius/i-essentials';

export class MailFile {
  public baseSur?: number;
  public centreNumerisation?: DigitalCentersVMDTO;
  public centreNumerisationId?: number;
  public createdByContactId?: number;
  public dateUpload?: string;
  public description?: string;
  public editeurSourceType?: string;
  public extension?: string;
  public guid?: string;
  public id?: number;
  public isLastVersion?: boolean;
  public isPrincipal?: boolean;
  public mailId?: number;
  public modeleId?: number;
  public name?: string;
  public pastellCircuitId?: number;
  public pastellDateLimite?: string;
  public pastellDocumentId?: number;
  public pastellStatus?: PastellStatus;
  public procedureValidationCreeParContactId?: number;
  public procedureValidationId?: number;
  public procedureValidationSignatureId?: number;
  public procedureValidationSignatureOk?: number;
  public procedureValidationSignatureRoleId?: number;
  public procedureValidationSignatureServiceId?: number;
  public procedureValidationValidationId?: number;
  public procedureValidationValidationOk?: number;
  public procedureValidationValidationRoleId?: number;
  public procedureValidationValidationServiceId?: number;
  public signataireRefuse?: boolean;
  public signataireRefuseLe?: string;
  public signataireSigne?: boolean;
  public signataireSigneLe?: string;
  public version?: number;

  // added by frontend
  public canPerformValidateAction?: boolean;
  public canPerformSignatureAction?: boolean;
  public hasExtensionInDescription?: boolean;
  public hasRightToNewVersion?: boolean;
  public statusPastellLabel?: string;
  public downloadFileRight?: boolean;
  public previousStep?: MailPreviousValidationDTO[];

  // trop peu explicite pour être sur qu'ils existent/ existent pas
  public sender?: EmailSender;
  public validationStatus?: string;
  public signatureStatus?: string;
  public type?: string;
  public contacts?: Partial<Contact>[];

  constructor(data?) {
    Object.assign(this, data);
  }
}

export class MailFilesWithRights {
  id: number;
  mailId: number;
  editeurSourceType: string;
  guid: string;
  baseSur: number;
  modeleId: number;
  createdByContactId: number;
  version: number;
  isLastVersion: boolean;
  isPrincipal: boolean;
  name: string;
  extension: string;
  description: string;
  dateUpload: string;
  signataireSigne: boolean;
  signataireSigneLe: string;
  signataireRefuse: boolean;
  signataireRefuseLe: string;
  procedureValidationId: number;
  procedureValidationCreeParContactId: number;
  procedureValidationValidationOk: number;
  procedureValidationSignatureOk: number;
  procedureValidationValidationId: number;
  procedureValidationValidationRoleId: number;
  procedureValidationValidationServiceId: number;
  procedureValidationSignatureId: number;
  procedureValidationSignatureRoleId: number;
  procedureValidationSignatureServiceId: number;
  pastellCircuitId: number;
  pastellDocumentId: number;
  pastellDateLimite: string;
  pastellStatus: PastellStatus;
  centreNumerisationId: number;
  centreNumerisation: DigitalCentersVMDTO;
  rights: {
    addNewVersion: {
      authorized: boolean;
      errorCode: number;
      errorMessage: string;
    };
    canValidate: boolean;
    canSign: boolean;
  };

  // Added by frontend
  hasExtensionInDescription?: boolean;
  hasRightToNewVersion?: boolean;
  canPerformValidateAction?: boolean;
  canPerformSignatureAction?: boolean;
  statusPastellLabel?: string;

  constructor(data?: MailFilesWithRightsDTO) {
    Object.assign(this, data);
  }
}

export class MailFileParams {
  description: string;
  editeurSourceType: string;
}

export class MailsFilesAcceptValidationParams {
  files?: {
    fileId?: number;
    justification?: string;
  }[];
}

export class MailsFilesRefuseValidationParams {
  files: MailsFilesRefuseValidationParamsFiles[];
}

export class MailsFilesRefuseValidationParamsFiles {
  fileId?: number;
  previousStepId?: number;
  contactId?: number;
  replacementContactId?: number;
  justification?: string;
  name?: string; // added by frontend
}

export class MailsFilesRefuseSignatureParams {
  justification?: string;
  dateRefus?: string;
}

export class MailFileVersionDisplayedDropdown implements MailFileDto {
  //MailFileDto
  id: number;
  mailId: number;
  editeurSourceType: string;
  guid: string;
  baseSur: number;
  modeleId: number;
  createdByContactId: number;
  version: number;
  isLastVersion: boolean;
  name: string;
  extension: string;
  description: string;
  dateUpload: string;
  signataireSigne: boolean;
  signataireSigneLe: string;
  signataireRefuse: boolean;
  signataireRefuseLe: string;
  procedureValidationId: number;
  procedureValidationCreeParContactId: number;
  procedureValidationValidationOk: number;
  procedureValidationSignatureOk: number;
  procedureValidationValidationId: number;
  procedureValidationValidationRoleId: number;
  procedureValidationValidationServiceId: number;
  procedureValidationSignatureId: number;
  procedureValidationSignatureRoleId: number;
  procedureValidationSignatureServiceId: number;
  pastellCircuitId: number;
  pastellDocumentId: number;
  pastellDateLimite: string;
  pastellStatus: PastellStatus;
  centreNumerisationId: number;
  centreNumerisation: DigitalCentersVMDTO;

  label: string;
  value: number;
  constructor(data: MailFileDto) {
    Object.assign(this, data);
    const formattedDate = DateUtils.format(new Date(data.dateUpload), 'DD/MM/YYYY');
    this.label = data.description + ' (' + formattedDate + ')';
    this.value = data.id;
  }
}
